module.exports = __webpack_public_path__ + "img/resized-APP-0021-1.94fc0a1a.png";